module.exports = require('../../es/array/find');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/features/array/find.js
// module id = 167
// module chunks = 0